<template>
  <div class="profile-settings-language text-center">
    <TopMenu
      :title="$t('PROFILE.LANGUAGE.PAGE_LABEL')"
      back-to="/dashboard/profile"
      dark-background/>
    <div class="container-fluid content">
      <div class="row-item-transparent-with-border mt-3 mb-4 text-left">
        <h3>{{ $t('PROFILE.LANGUAGE.HEADER') }}</h3>
      </div>
      <div class="choice-group mr-3 ml-3">
        <ChoiceRadioGroup
          v-model="lang"
          :choices="[{value:'fr', text:$t('PROFILE.LANGUAGE.FRENCH')}, {value:'en', text:$t('PROFILE.LANGUAGE.ENGLISH')}]" />
      </div>
      <ActionButton
        class="btn btn-lg btn-primary btn-block mt-3 mb-1"
        @click="save">{{ $t("PROFILE.LANGUAGE.SAVE_BUTTON") }}</ActionButton>
    </div>
    <BottomMenu />
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import TopMenu from '@/components/Menu/TopMenu';
import BottomMenu from '@/components/Menu/BottomMenu';
import TextLink from '@/components/Utils/TextLink';
import ActionButton from '@/components/Actions/ActionButton';
import ChoiceRadioGroup from '@/components/Forms/ChoiceRadioGroup';

export default {
  name: 'ProfileLanguage',
  components: {
    ActionButton,
    TextLink,
    TopMenu,
    BottomMenu,
    ChoiceRadioGroup,
  },
  data() {
    return {
      lang: null,
    };
  },
  computed: {
    ...mapState('member', ['selectedMember']),
  },
  watch: {
    selectedMember: {
      handler(newVal) {
        if (newVal) {
          this.lang = newVal.language;
        } else {
          this.lang = '';
        }
      },
      immediate: true,
    },
  },
  methods: {
    save() {
      this.$store.dispatch('member/changeLanguage', this.lang).then(() => {
        this.$i18n.locale = this.lang;
        moment.locale(`${this.selectedMember.language}_CA`);
        this.$store.commit('alerts/setAlert', {
          msg: 'PROFILE.LANGUAGE.CONFIRMATION_MESSAGE',
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.profile-settings-language {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
}
</style>
